/* Power Source dropdown (snippets/sm_power-source-select.liquid): open / close, keyboard, and the
   toggle's copy of the selected option. Selecting a value is left to the product section's
   configurator, which already handles [data-sm-option-value] clicks (capture phase on the section),
   marks the active option and hides Camouflaged ones. One set of document listeners, so it keeps
   working when sections re-render. */
(() => {
  if (window.smPowerSelectInit) return;
  window.smPowerSelectInit = true;

  const SELECT = '[data-sm-power-select]';
  const visibleOptions = (select) =>
    Array.from(select.querySelectorAll('[role="option"]')).filter((option) => !option.hidden);

  /* Copy the active option's text into the toggle; placeholder when nothing visible is active
     (e.g. Cordless, which stays a tab, is selected). is-selected gives the toggle the tabs' active look. */
  const sync = (select) => {
    const value = select.querySelector('[data-sm-power-select-value]');
    if (!value) return;
    let active = null;
    select.querySelectorAll('[role="option"]').forEach((option) => {
      const isActive = option.classList.contains('active') && !option.hidden;
      option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) active = option;
    });
    if (select.classList.contains('is-selected') !== Boolean(active)) select.classList.toggle('is-selected', Boolean(active));
    const source = active ? active.querySelector('.power_source-select__text') : select.querySelector('[data-sm-power-select-placeholder]').content;
    const html = active ? source.outerHTML : Array.from(source.childNodes).map((node) => node.outerHTML || node.textContent).join('');
    if (value.innerHTML !== html) value.innerHTML = html;
  };

  const setOpen = (select, open, focusToggle = false) => {
    const toggle = select.querySelector('[data-sm-power-select-toggle]');
    const list = select.querySelector('[data-sm-power-select-list]');
    if (!toggle || !list) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    list.hidden = !open;
    if (open) {
      const options = visibleOptions(select);
      (options.find((option) => option.classList.contains('active')) || options[0])?.focus();
    } else if (focusToggle) {
      toggle.focus();
    }
  };

  const closeAll = (except) => {
    document.querySelectorAll(`${SELECT} [data-sm-power-select-toggle][aria-expanded="true"]`).forEach((toggle) => {
      const select = toggle.closest(SELECT);
      if (select !== except) setOpen(select, false);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-sm-power-select-toggle]');
    if (toggle) {
      const select = toggle.closest(SELECT);
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      closeAll(select);
      setOpen(select, open);
      return;
    }
    const option = event.target.closest(`${SELECT} [role="option"]`);
    if (option) {
      /* The configurator has already selected it (capture phase); close and show it. */
      const select = option.closest(SELECT);
      setOpen(select, false, true);
      sync(select);
      return;
    }
    if (!event.target.closest(SELECT)) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    const select = event.target.closest && event.target.closest(SELECT);
    if (!select) return;
    const list = select.querySelector('[data-sm-power-select-list]');
    if (event.key === 'Escape' && list && !list.hidden) {
      event.preventDefault();
      setOpen(select, false, true);
      return;
    }
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
    if (event.target.matches('[data-sm-power-select-toggle]')) {
      event.preventDefault();
      setOpen(select, true);
      return;
    }
    const options = visibleOptions(select);
    const index = options.indexOf(event.target);
    if (index === -1) return;
    event.preventDefault();
    let next = index;
    if (event.key === 'ArrowDown') next = Math.min(index + 1, options.length - 1);
    if (event.key === 'ArrowUp') next = Math.max(index - 1, 0);
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = options.length - 1;
    options[next].focus();
  });

  /* Keyboard focus leaving the dropdown closes it. */
  document.addEventListener('focusout', (event) => {
    const select = event.target.closest && event.target.closest(SELECT);
    if (select && event.relatedTarget && !select.contains(event.relatedTarget)) setOpen(select, false);
  });

  /* Re-sync whenever the configurator changes an option (variant changes from the cordless card,
     Camouflage hiding a value) or a section re-renders with a new dropdown. */
  const syncAll = () => document.querySelectorAll(SELECT).forEach(sync);
  const observer = new MutationObserver((mutations) => {
    const touched = new Set();
    mutations.forEach((mutation) => {
      const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      const select = target && target.closest(SELECT);
      if (select && mutation.type === 'attributes') touched.add(select);
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches(SELECT)) touched.add(node);
          node.querySelectorAll && node.querySelectorAll(SELECT).forEach((found) => touched.add(found));
        });
      }
    });
    touched.forEach(sync);
  });

  const start = () => {
    syncAll();
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
